<div class="progress-bar-container">
    <div class="progress-bar disabled" *ngFor="let item of Arr(total).fill(1);let i=index" [ngClass]="{'active': progress>i,'disabled':progress<=i}">
    </div>

 </div>
 <div class="step-name">{{stepText}} {{progress}} {{stepOfText}} {{total}} - {{stepName}}</div>